import { SmartStorage, SmartHttp } from "smart-core-util";
import { setCookie, getCookie, removeCookie } from "tiny-cookie";
import { Toast } from "vant";

const $ajax = new SmartHttp({
  baseURL: process.env.VUE_APP_GATEWAY,
  alert: Toast,
  disableLoadingAnimation: true,
}).request;
const setting = {
  token: "access_token",
  userId: "userId",
  tenant_code: "tenant_code",
  tenant: "tenant_code",
  tenant_id: "tenant_id",
  tenantId: "tenant_id",
  PhoneNumberConfirmed: "PhoneNumberConfirmed",
  role_codes: "role_codes",
  directory_id: "directory_id",
};
export default class CacheData {
  static install() {
    this.setiDomain();
    let url = window.location.search.substring(1);
    let urlParamsObj = {};
    if (url) {
      let urlParams = url.split("&");
      urlParams.forEach((item) => {
        let temp = item.split("=");
        urlParamsObj[temp[0]] = temp[1];
      });
    }
    if (getCookie("redirectA1Url")) {
      window.location.href = getCookie("redirectA1Url");
      removeCookie("redirectA1Url");
      removeCookie("redirectA1Url", { domain: window.idomain });
      return;
    }
    return new Promise(function (resolve) {
      if (urlParamsObj && urlParamsObj.rad) {
        let params = {
          sessionId: urlParamsObj.rad || "",
        };
        setCookie("version", 1);
        $ajax
          .post("/api/statestore/redis/query", params)
          .then((queryResponse) => {
            if (queryResponse && queryResponse.success) {
              CacheData.setData(queryResponse.content);
              resolve(queryResponse);
            } else {
              resolve();
            }
          })
          .catch((error) => {
            resolve(error);
          });
      } else {
        resolve();
      }
    });
  }

  static setData(d) {
    for (var i in setting) {
      SmartStorage.set(i, d[setting[i]]);
    }
    CacheData.setCooikes(d);
  }

  static setCooikes(response) {
    let expiresTimes = "31104000s";
    if (response.container == "h5") {
      expiresTimes = "Session";
    }
    let config = { expires: expiresTimes, domain: window.idomain };
    CacheData.appendCookie(response, setting, config);
  }

  static appendCookie(data, setting, config) {
    setCookie("token", data.access_token || data.token, config);
    for (var i in setting) {
      i != "token" && setCookie(i, data[setting[i]], config);
    }
  }

  static setiDomain() {
    let domain = document.domain;
    const re = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
    let isIP = re.test(domain);
    let isLocalhost = domain == "localhost";
    domain =
      isIP || isLocalhost ? domain : domain.substring(domain.indexOf(".") + 1);
    window.idomain = domain;
  }
}
